var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoresIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.204,
    height: 61.204,
    viewBox: "0 0 61.204 61.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_903",
    "data-name": "Groupe 903",
    transform: "translate(-641 -2000.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_882",
    "data-name": "Groupe 882",
    transform: "translate(648.078 2027.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_883",
    "data-name": "Groupe 883",
    transform: "translate(0.007 1.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_181",
    "data-name": "Trac\\xE9 181",
    d: "M55.994,8.149a9.745,9.745,0,0,1,1.541,4.407,5.95,5.95,0,1,1-11.9,0,9.378,9.378,0,0,1,1.4-4.209",
    transform: "translate(-28.051 -5.872)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_182",
    "data-name": "Trac\\xE9 182",
    d: "M.012,2.4S15.911.934,18.766,1.349c.833.121,1.634-.124.013,2.806",
    transform: "translate(-0.012 -1.275)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_183",
    "data-name": "Trac\\xE9 183",
    d: "M90.621,2.4S74.722.934,71.867,1.349c-.833.121-1.634-.124-.013,2.806",
    transform: "translate(-43.588 -1.275)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoresIcon);
export default __webpack_public_path__ + "static/media/PoresIcon.0b36302b617a5fb1f6fccd330302ff3e.svg";
export { ForwardRef as ReactComponent };